import { useRef } from 'react';
import { useRouter } from 'next/router';

export function useOfferCategoryNavigation(initialSelectedCategory?: string) {
  const router = useRouter();

  const categoryFromRoute = Array.isArray(router.query.category)
    ? router.query.category[0]
    : router.query.category;

  const selectedCategory =
    categoryFromRoute?.toLowerCase() ?? initialSelectedCategory ?? 'allCategories';

  const listRef = useRef<HTMLDivElement>(null);

  const scrollToList = () => {
    if (listRef.current) {
      listRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleCategorySelect = (tag: string) => {
    const nextQuery = { ...router.query };
    if (tag === 'allCategories') {
      delete nextQuery.category;
    } else {
      nextQuery.category = tag;
    }

    // asPath used for passing the visible path without tenant prefix or query string params
    const visiblePathname = router.asPath.split('?')[0];

    void router
      .replace(
        {
          pathname: router.pathname,
          query: nextQuery,
        },
        {
          pathname: visiblePathname,
          query: nextQuery,
        },
        { shallow: true },
      )
      .then(() => {
        scrollToList();
      });
  };

  return { listRef, handleCategorySelect, selectedCategory };
}
